<script setup>
import { computed, onBeforeMount, watch, ref } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

import { FormProject } from '@/components/forms'

const store = useStore()
const route = useRoute()

const projectId = computed(() => route.params.project_id ? parseInt(route.params.project_id) : null)
const project = computed(() => store.getters['project/current'])
const members = computed(() => store.getters['project/getMembers'])
const isLoading = ref(true)

// Create a fake project object for new project creation
const createProjectData = computed(() => {
  if (projectId.value) {
    // Creating a sub-project - use parent project data
    return project.value
  } else {
    // Creating a regular project - use minimal project data
    const orgs = store.getters['org/getOrgs']
    const currentOrg = orgs.length > 0 ? orgs[0] : null
    return {
      project_id: null,
      organization_id: currentOrg?.organization_id || null,
      parent_id: null
    }
  }
})

onBeforeMount(async () => {
  if (projectId.value) {
    // Load parent project data if creating a sub-project
    await store.dispatch('project/fetchProject', projectId.value)
    await store.dispatch('project/fetchMembers', projectId.value)
  } else {
    // Load organization data for regular project creation
    await store.dispatch('org/fetchOrgs')
  }
  isLoading.value = false
})

watch(() => projectId.value, async (value) => {
  isLoading.value = true
  if (value) {
    await store.dispatch('project/fetchProject', value)
    await store.dispatch('project/fetchMembers', value)
  } else {
    await store.dispatch('org/fetchOrgs')
  }
  isLoading.value = false
})
</script>

<template>
  <div class="p-2">
    <div v-if="!isLoading && createProjectData" :key="createProjectData?.project_id || 'new'">
      <FormProject
        :project="createProjectData"
        :key="createProjectData?.project_id || 'new'"
        :members="members || []"
      />
    </div>
    <div v-else>
      <p>Loading...</p>
    </div>
  </div>
</template>
